import React from "react";
import {
  FaBell,
  FaChartLine,
  FaCode,
  FaCoins,
  FaKey,
  FaMobileAlt,
  FaQrcode,
  FaSnowflake,
  FaShieldAlt,
  FaCloudUploadAlt,
  FaExchangeAlt,
  FaUsers,
  FaSlidersH,
  FaPlug,
  FaUserAlt,
  FaBellSlash,
} from "react-icons/fa";

function Functionalities() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Features & Functionalities of our Cryptocurrency Wallet
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="services-style-four-items">
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={35} />
                      </div>
                      <h4>Multi-Currency Support</h4>
                      <p>
                        Develop wallets that support multiple blockchain
                        networks, enabling users to manage a wide range of
                        cryptocurrencies (e.g., Bitcoin, Ethereum, Solana)
                        within a single interface.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaMobileAlt size={35} />
                      </div>
                      <h4>Cross-Platform Compatibility</h4>
                      <p>
                        Wallets are built to work seamlessly across platforms,
                        including mobile (iOS/Android), desktop, and web,
                        ensuring a consistent user experience on any device.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaKey size={35} />
                      </div>
                      <h4>Private Key Management</h4>
                      <p>
                        Implement advanced cryptographic algorithms to securely
                        generate and manage private keys. Offer users the option
                        to store private keys in secure hardware wallets, or
                        within encrypted local storage.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaUserAlt size={35} />
                      </div>
                      <h4>User-Friendly Interface</h4>
                      <p>
                        Design intuitive, easy-to-navigate UI/UX for both novice
                        and experienced users, allowing for smooth management of
                        digital assets and execution of transactions.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaChartLine size={35} />
                      </div>
                      <h4>Real-Time Transaction Tracking</h4>
                      <p>
                        Provide real-time updates on transaction statuses,
                        confirmations, and fees across blockchain networks,
                        allowing users to monitor the progress of their
                        transactions.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaBell size={35} />
                      </div>
                      <h4>Push Notifications & Alerts</h4>
                      <p>
                        Implement real-time push notifications for transaction
                        updates, market fluctuations, and other key wallet
                        events, keeping users informed at all times.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCode size={35} />
                      </div>
                      <h4>Support for Decentralized Applications (dApps)</h4>
                      <p>
                        Integrate support for interacting with decentralized
                        applications (dApps), allowing users to engage in DeFi
                        protocols, NFT marketplaces, and more directly from the
                        wallet.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaQrcode size={35} />
                      </div>
                      <h4>QR Code Support</h4>
                      <p>
                        Enable QR code scanning for fast and easy cryptocurrency
                        transactions, simplifying the process for both sending
                        and receiving digital assets.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaShieldAlt size={35} />
                      </div>
                      <h4>Enhanced Security Protocols</h4>
                      <p>
                        Incorporate cutting-edge security measures like
                        multi-signature authentication, biometric security, and
                        two-factor authentication (2FA) for additional
                        protection.
                      </p>
                    </div>

                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCloudUploadAlt size={35} />
                      </div>
                      <h4>Backup and Recovery Mechanism</h4>
                      <p>
                        Integrate robust backup options, such as encrypted
                        recovery phrases or private key export, ensuring users
                        can recover their wallets in case of data loss.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaSnowflake size={35} />
                      </div>
                      <h4>Cold and Hot Wallet Options</h4>
                      <p>
                        Develop both hot wallets for easy access to funds via
                        the internet and cold wallets for offline storage to
                        maximize security for long-term holdings.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaBellSlash size={35} />
                      </div>
                      <h4>Push Notifications & Alerts</h4>
                      <p>
                        Implement real-time push notifications for transaction
                        updates, market fluctuations, and other key wallet
                        events, keeping users informed at all times.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaExchangeAlt size={35} />
                      </div>
                      <h4>Integrated Exchange Functionality</h4>
                      <p>
                        Integrate with decentralized or centralized exchanges
                        (DEX/CEX) to allow seamless in-wallet trading,
                        conversion of assets, and price monitoring.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaUsers size={35} />
                      </div>
                      <h4>Multi-Signature Support</h4>
                      <p>
                        Add multi-signature features, enabling wallets to
                        require multiple private keys for transaction
                        authorization, perfect for businesses or collaborative
                        funds.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaSlidersH s size={35} />
                      </div>
                      <h4>Customizable Fee Structure</h4>
                      <p>
                        Allow users to adjust transaction fees according to
                        their priorities—whether they prefer faster
                        confirmations or lower transaction costs.
                      </p>
                    </div>
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaPlug size={35} />
                      </div>
                      <h4>API Integration</h4>
                      <p>
                        Provide APIs for seamless integration with third-party
                        services such as payment gateways, blockchain explorers,
                        and external applications to expand wallet
                        functionality.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Functionalities;
